
import Vue from "vue";
import CoownersList from "@/components/common/CoownersList.vue";
import PaginationSelect from "@/components/common/PaginationSelect.vue";

import affiliateService from "@/services/admin/affiliateService";

import { MetaNames } from "@/constants";
import { UserInfo } from "@/types/User";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";

export default Vue.extend({
  name: "AffiliateList",
  components: {
    CoownersList,
    PaginationSelect
  },
  data: function () {
    return {
      title: MetaNames.AdminAffiliates,      
      affiliateHomeStates: [] as any[],
      loading: false,
      isError: false,
      errorMessage: "",
      paginatedResponse: {} as PaginatedResponse<object>,
      searchParams: {
        affiliateId: "",
        affiliateName: "",
        affiliateRep: "",
        state: "",
        affiliatePresident: "",
        membershipStatus: null as any,
      },
      membershipStatusFilterIdx: 0,
      options: {} as PaginationOptions,
      headers: [
        { text: "", align: "left", value: "affiliateId", width: "10%" },
        { text: "", align: "left", value: "affiliateName", width: "15%" },
        { text: "", align: "left", value: "state", width: "10%" },
        { text: "", align: "left", value: "affiliateRep", width: "25%" },
        { text: "Affiliate President", align: "left", value: "affiliatePresident", width: "25%" },
        { text: "Member Status", align: "left", value: "membershipStatus" },
        { text: "Member Expiry Date", align: "left", value: "membershipExpiryDate" },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50, 100] },
    };
  },
  created: function () {    
    affiliateService.getAffiliateHomeStates().then((res: any) => {
          this.affiliateHomeStates = res.states;
    });
    this.load();
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    }
  },
  methods: {
    toggleCheckbox: function () {
      var membershipStatusStates = [null, true, false];
      var next = ++this.membershipStatusFilterIdx % membershipStatusStates.length;
      this.membershipStatusFilterIdx = next;
      this.searchParams.membershipStatus = membershipStatusStates[next];
    },
    createNewAffiliate: function () {
      this.$router.push({ path: '/admin/affiliates' });
    },
    clearAllFilters: function () {
      this.options.page = 1;
      this.options.itemsPerPage = 10;
      this.searchParams = {
        affiliateId: "",
        affiliateName: "",
        affiliateRep: "",
        state: "",
        affiliatePresident: "",
        membershipStatus: null as any,
      };
      this.membershipStatusFilterIdx = 0;
    },
    load: async function () {
      this.loading = true;

      const {
        page,
        itemsPerPage,
      } = this.options;

      try {
        const response = await affiliateService.getAffiliatesList({
          ...this.options,
          page: (page ?? 1) - 1,
          itemsPerPage: itemsPerPage ?? 10
        }, this.searchParams);

        this.loading = false;
        this.paginatedResponse = response;
      } catch (ex: any) {
        console.log(ex.response.data.errors)

        this.loading = false;
        this.isError = true;
        
        const descriptiveMessage = ex.response.data.errors
          ? `Error(s): ${Object.values(ex.response.data.errors).join(" & ")}`
          : null

        this.errorMessage = descriptiveMessage ?? ex.message ?? "Unknown error occurred when retrieving data.";
      }
    },
    applyFilter() {
      this.options.page = 1;
      this.options.itemsPerPage = 10;

      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
